//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import TimelineItemCard from "./utils/timeline-card.vue";
import TimelineCardFooter from "./utils/timeline-card-footer.vue";
import CalendarEventInformation from "@Broker/@Modules/util-components/calendar/calendar-event-information.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TimelineEvent",
  components: {
    TimelineItemCard,
    TimelineCardFooter,
    CalendarEventInformation
  },
  props: {
    agentUsername: {
      type: String,
      default: ""
    },
    metadata: {
      type: Object,
      required: true
    },
    createdAt: {
      type: String,
      required: true
    }
  },
  computed: {
    startTime() {
      var _this$metadata$when$s;
      return moment.unix((_this$metadata$when$s = this.metadata.when.start_time) != null ? _this$metadata$when$s : this.metadata.when.startTime).local().toDate();
    },
    endTime() {
      var _this$metadata$when$e;
      return moment.unix((_this$metadata$when$e = this.metadata.when.end_time) != null ? _this$metadata$when$e : this.metadata.when.endTime).local().toDate();
    }
  }
});